module.exports = __webpack_public_path__ + "static/media/12.b6cdb956.jpg";